import React, { Component } from 'react';
import Highlighter from 'react-highlight-words';
import { handleCopy, convertDate, dateFormat, disabledDate, sortWithParse, convertDateForDatePicker, massagePasswords, renderAttempt } from './util';
import { Table, Input, InputNumber, Popconfirm, Form, DatePicker, Button, Icon, Tooltip, notification, Tag, Row, Select } from 'antd';
import moment from 'moment';

import { allowProtectionType } from '../../utils';

const EditableContext = React.createContext();

const { Option } = Select;

class EditableCell extends Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber min={1} />;
    }
    if (this.props.inputType === 'date') {
      return (
        <DatePicker
          format={dateFormat}
          disabledDate={disabledDate}
        />)
    }
    return <Input maxLength={255} />;
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              initialValue: inputType === 'date' ? convertDateForDatePicker(record[dataIndex], dateFormat) : record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
            children
          )}
      </td>
    );
  };

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
  }
}


class TableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingID: '',
      searchText: '',
      saveButton: 'Save',
      selectedRowKeys: [],
      isDeleteSelectedPassword: false,
    };
    this.isEditing = this.isEditing.bind(this);
    this.cancel = this.cancel.bind(this);
    this.save = this.save.bind(this);
    this.components = {
      body: {
        cell: EditableCell,
      },
    };
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 163, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 85, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 70 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Tooltip title={text}>
        <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        </div>
      </Tooltip>
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  initColumns = () => {
    const { handleDeletePassword, handleSetPasswordStatus, levels } = this.props;
    let columns = [
      {
        title: 'Password',
        dataIndex: 'password',
        width: 180,
        key: 'password',
        fixed: 'left',
        render: (text) => (
          <Tooltip title={text}>
            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{text}</div>
          </Tooltip>
        ),
        ...this.getColumnSearchProps('password'),
        sorter: (a, b) => a.password.localeCompare(b.password),
        sortDirections: ['descend', 'ascend'],
        onCell: () => {
          return {
            style: {
              whiteSpace: 'nowrap',
              maxWidth: 150,
            }
          }
        },
      },
      {
        title: 'Label',
        dataIndex: 'label',
        width: 140,
        editable: true,
        key: 'label',
        render: (text) => (
          <Tooltip title={text}>
            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '120px' }}>{text}</div>
          </Tooltip>
        ),
      },
      {
        title: 'Post Types',
        dataIndex: 'post_types',
        width: 140,
        key: 'post_types',
        render: (text) => {
          if (!text || !ppwMasterPasswords || !ppwMasterPasswords.postTypes) {
            return '';
          }
          const postTypes = text.split(';');
          const postTypesLabel = postTypes.reduce(function (carry, value) {
            const foundIndex = ppwMasterPasswords.postTypes.findIndex((postType) => postType.key === value);
            if (foundIndex > -1) {
              carry.push(ppwMasterPasswords.postTypes[foundIndex].value);
            }
            return carry;
          }, []);
          return (
            <span>
              {postTypesLabel.map(tag => (
                <Tag color="orange" key={tag}>
                  {tag}
                </Tag>
              ))}
            </span>
          )
        },
      },
      {
        title: 'Type',
        dataIndex: 'campaign_app_type',
        key: 'campaign_app_type',
        width: 160,
        sortDirections: ['descend', 'ascend'],
        render: (text) => {
          if (text === 'master_global') {
            return 'Global';
          }
          if (!text) {
            return;
          }

          const rolesText = text.split(';').map(value => value.split('_')[2]).join(', ');
          const roleContent = `Role (${rolesText})`;

          return (
            <Tooltip title={roleContent}>
              <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '120px' }}>{roleContent}</div>
            </Tooltip>
          )
        },
        sorter: (a, b) => a.campaign_app_type.localeCompare(b.campaign_app_type),

      },
      {
        title: () => {
          return (
            <Tooltip title="Is the password active?">
              <div>Status</div>
            </Tooltip>
          )
        },
        dataIndex: 'show_is_activated',
        key: 'show_is_activated',
        width: 80,
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => a.show_is_activated.localeCompare(b.show_is_activated),
        render: (value, record) => {
          return record.show_is_activated === 'Active' ? (<span className='ppw-master-password-status' style={{ color: 'green' }}>{record.show_is_activated}</span>)
            : (<span className='ppw-master-password-status' style={{ color: 'red' }}>{record.show_is_activated}</span>);
        }
      },
      {
        title: () => {
          return (
            <Tooltip title="Total number of times the password is used">
              <div>Usage</div>
            </Tooltip>
          )
        },
        dataIndex: 'hits_count',
        key: 'hits_count',
        width: 80,
        sorter: (a, b) => sortWithParse(a.hits_count, b.hits_count),
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Usage Limit',
        dataIndex: 'usage_limit',
        key: 'usage_limit',
        width: 110,
        editable: true,
        sorter: (a, b) => sortWithParse(a.usage_limit, b.usage_limit),
        sortDirections: ['descend', 'ascend'],
        render: (text) => {
          return text ? `${text} ${renderAttempt(parseInt(text))}` : 'Unlimited';
        }
      },
      {
        title: 'Password Expiry',
        dataIndex: 'expired_date',
        key: 'expired_date',
        width: 180,
        editable: true,
        sorter: (a, b) => sortWithParse(a.expired_date, b.expired_date),
        sortDirections: ['descend', 'ascend'],
        render: (cellData) => {
          if (cellData) {
            const date = new Date(cellData * 1000);
            return date.toLocaleString();
          }
          return 'Never';
        }
      },
      {
        title: 'Created Time',
        dataIndex: 'created_time',
        key: 'created_time',
        sorter: (a, b) => sortWithParse(a.created_time, b.created_time),
        sortDirections: ['descend', 'ascend'],
        render: (cellData) => {
          const date = new Date(cellData * 1000);
          cellData = date.toLocaleString();
          return cellData;
        },
        onCell: () => {
          return {
            style: {
              minWidth: 160,
            }
          }
        },
        onHeaderCell: () => {
          return {
            style: {
              minWidth: 160,
            }
          }
        }
      },
      {
        title: 'Actions',
        key: 'action',
        dataIndex: 'id',
        fixed: 'right',
        width: 110,
        render: (cellData, record) => {
          const changeStatusLabel = record.is_activated === "1" ? 'Deactivate' : 'Activate';
          const { editingID, saveButton } = this.state;
          const editable = this.isEditing(record);
          if (editable) {
            return (
              <span>
                <EditableContext.Consumer>
                  {form => (
                    <a
                      id='ppwp-save-password'
                      onClick={() => {
                        this.setState({
                          saveButton: 'Saving'
                        });
                        this.save(form, record.id).finally(() => {
                          notification['success']({
                            message: 'PPWP Lite',
                            description: 'Great! You’ve updated the password successfully.',
                          });
                          this.setState({
                            saveButton: 'Save'
                          });
                          this.cancel();
                        })
                      }}
                      style={{ marginRight: 8 }}
                    >
                      {saveButton}
                    </a>
                  )}
                </EditableContext.Consumer>
                <Popconfirm title="Sure to cancel?" onConfirm={() => this.cancel(record.id)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            )
          }
          return editingID !== '' ? '' : (
            <div>
              <span id="ppw_popup_copy_password" className="pdav3_table_actions">
                <Tooltip title="Copy Password">
                  <span>
                    <icon
                      className="fa fa-clone"
                      onClick={(evt) => evt.preventDefault() || handleCopy(record.password)}
                    >
                    </icon>
                  </span>
                </Tooltip>
              </span>
              <span id="ppw_popup_edit_password" className="pdav3_table_actions">
                <Tooltip title="Edit">
                  <span>
                    <icon
                      className="fa fa-pencil-square-o"
                      aria-hidden="true"
                      onClick={() => this.edit(record.id)}
                    >
                    </icon>
                  </span>
                </Tooltip>
              </span>
              <span id="ppw_popup_status_password" className="pdav3_table_actions">
                <Tooltip title={changeStatusLabel}>
                  <span>
                    <icon
                      className={changeStatusLabel === 'Activate' ? 'fa fa-lock' : 'fa fa-unlock-alt'}
                      aria-hidden="true"
                      onClick={handleSetPasswordStatus(cellData, record.is_activated)}
                    >
                    </icon>
                  </span>
                </Tooltip>
              </span>
              <span id="ppw_popup_delete_password" className="pdav3_table_actions">
                <Tooltip title="Delete">
                  <span>
                    <icon
                      className="fa fa-trash"
                      type="delete"
                      onClick={handleDeletePassword(record.id)}
                    >
                    </icon>
                  </span>
                </Tooltip>
              </span>
            </div>
          )
        },
      },
    ];

    if (allowProtectionType()) {
      columns.splice(2, 0,
        {
          title: 'Protection Types',
          dataIndex: 'protection_types',
          width: 200,
          key: 'protection_types',
          render: (text) => {
            const { protectionTypes: globalProtectionTypes } = ppwMasterPasswords;
            if (!text) {
              return (
                <Tag color="orange" key="single">
                  {globalProtectionTypes[0].value}
                </Tag>
              );
            }
            let protectionTypes = text.split(';');
            protectionTypes = protectionTypes.map(protectionType => {
              const foundIndex = globalProtectionTypes.findIndex(p => p.key === protectionType);
              if (foundIndex === -1) {
                return protectionType;
              }

              return globalProtectionTypes[foundIndex].value;
            });
            return (
              <span>
                {protectionTypes.map(tag => (
                  <Tag color="orange" key={tag}>
                    {tag}
                  </Tag>
                ))}
              </span>
            )
          },
      }, 
      );
    }


    return columns;
  }

  render() {
    const listPasswords = massagePasswords(this.props.data);
    const { selectedRowKeys } = this.state;
    const columns = this.initColumns();
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      fixed: true,
      columnWidth: '25px'
    };

    const columnsEditable = columns.map(col => {
      if (!col.editable) {
        return col;
      }
      let inputType = '';
      switch (col.dataIndex) {
        case 'expired_date':
          inputType = 'date';
          break;
        case 'hits_count':
          inputType = 'hits_count';
          break;
        default:
          inputType = 'text';
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    return (
      <EditableContext.Provider value={this.props.form}>
        <Table
          bordered
          pagination={false}
          columns={columnsEditable}
          dataSource={listPasswords}
          rowClassName="editable-row"
          scroll={{ x: 1400, y: 500 }}
          components={this.components}
          rowKey={record => record.id}
          size="small"
          loading={this.props.loading}
          rowSelection={rowSelection}
          style={
            {
              minHeigh: 200,
            }
          }
          pagination={{
            onChange: () => {
              this.cancel();
              this.onSelectChange([]);
            },
            pageSizeOptions: ['10', '15', '20'],
            showSizeChanger: true,
            defaultPageSize: 10
          }}
          footer={() => (
            <Row>
                <Select
                showSearch
                style={{ width: 135, marginRight: 10 }}
                placeholder="Bulk Actions"
                allowClear={true}
                optionFilterProp="children"
                onChange={this.onChange}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                >
                  <Option value="remove">Delete</Option>
                </Select>
                <Button disabled={this.state.isDeleteSelectedPassword} onClick={this.clickApply}>
                    { this.state.isDeleteSelectedPassword ? 'Applying': 'Apply'}
                </Button>
            </Row>
          )}
        />
      </EditableContext.Provider>);
  }

  clickApply = () => {
    const { selectedBulkAction, selectedRowKeys } = this.state;
    if (!selectedBulkAction || selectedRowKeys.length === 0) {
      return;
    }
    switch (selectedBulkAction) {
      case 'remove':
        const { handleDeleteSelectedPasswords } = this.props;
        handleDeleteSelectedPasswords(selectedRowKeys, () => {
          this.onSelectChange([]);
        }, (status) => {
          this.setState({ isDeleteSelectedPassword: status });
        });
        return;
      default:
        return;
    }
  }

  onChange = (value) => {
    this.setState({ selectedBulkAction: value });
  }

  edit(id) {
    this.setState({ editingID: id });
  }

  cancel() {
    this.setState({ editingID: '' });
  };

  isEditing(record) {
    return record.id === this.state.editingID;
  };

  save = (form, id) => {
    return new Promise((resolve, reject) => {
      form.validateFields((error, row) => {
        if (error) {
          return reject(error);
        }
        const { handleChangeExpiredDate, handleChangeUsageLimit, handleChangeLabel } = this.props;
        const oldData = [...this.props.data];
        const index = oldData.findIndex(item => id === item.id);
        if (index === -1) {
          return resolve(false);
        }
        const item = oldData[index];
        const promises = [];
        if (row.usage_limit !== item.usage_limit) {
          promises.push(handleChangeUsageLimit(row.usage_limit, id));
        }
        if (row.expired_date && !convertDate(item.expired_date).isSame(row.expired_date, 'day')) {
          const timePicked = moment(`${row.expired_date.format(dateFormat)} ${moment().format('h:mm:ss a')}`);
          promises.push(handleChangeExpiredDate(timePicked.unix(), id));
        } else if ( ! row.expired_date && row.expired_date !== item.expired_date ) {
          promises.push(handleChangeExpiredDate( null, id));
        }
        if (row.label !== item.label) {
          promises.push(handleChangeLabel(row.label, id));
        }
        return Promise.all(promises)
          .then(() => resolve(true))
          .catch((err) => {
            reject(err);
          });
      });
    })
  }

}

const PasswordTable = Form.create()(TableComponent)
export default PasswordTable;



// WEBPACK FOOTER //
// ./components/PasswordTable/PasswordTable.js